module.exports = __webpack_public_path__ + "img/6.9670f1e5.png";